module.exports = __webpack_public_path__ + "img/community.4623442b.png";